// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_iq-0";
export var actionModalContentContainer = "_iq-1";
export var createTagButton = "_iq-2";
export var footerContainer = "_iq-7";
export var fullWidthDivider = "_iq-3";
export var hasCreateTagButton = "_iq-4";
export var noCreateTagButton = "_iq-5";
export var tagsContainer = "_iq-6";
export var tagsModalContentContainer = "_iq-8";